<template>
  <v-container>
    <v-row justify-center align-center justify="center">
      <v-col sm="8" md="6" lg="5">
        <SigninWrapper :show-signin="false" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SigninWrapper from '@/components/auth/SigninWrapper.vue';

export default {
  components: {
    SigninWrapper
  }
};
</script>
